import API from '@/api/homepage/homepage.js';
import { approvalTypeList } from '@/constants';
export default {
  data() {
    return {
      businessGroup: '',
      businessGroupMap: {
        园区: 'wy',
        物业: 'wy',
        仓储: 'cc',
        仓单: 'cd',
        多式联运: 'dsly',
        城矿: 'ck',
        物贸: 'wm',
        主数据: 'zsj',
      },
    };
  },
  mounted() {
    this.businessGroup = this.userInfo.businessGroup;
  },
  methods: {
    // 双击跳转
    dblclickEvent(value) {
      console.log('点击单据', value.row, value);
      this.multipleSelection = [value];
      const row = value.row;
      const path = this.handleParams(row);
      console.log('跳转', path);
      this.$router.push(path);
    },
    jumpToDetail(value) {
      console.log('点击单据', value);
      this.multipleSelection = [value];
      const row = value;
      const path = this.handleParams(row);
      console.log('跳转', path);
      this.$router.push(path);
    },
    // 重置分页
    resetPage() {
      // this.$refs.ipaginationRef.handleSizeChange(10);
    },
    // 路由跳转参数处理
    handleParams(row) {
      let orderName = this.orderName;
      console.log(this.orderName, this.businessGroup, this.activeTab, 'this.orderName');
      // const businessGroup = this.userInfo.businessGroup;
      let path = '';
      let query = {};
      let name = '';
      let title = '';
      // console.log(path, query, type, name, title);
      //   物业、仓储、仓单
      if (['wy', 'cc', 'cd'].includes(this.indexType)) {
        if (['租赁合同', '物业合同'].includes(orderName)) {
          console.log('进入租赁合同');
          // 详情
          if (this.activeTab == '02') {
            if (row.auditStatus === '01' || row.auditStatus === '04') {
              // 合同只是保存还未提交 待提交 审核驳回可编辑
              path = 'propert/editLeaseContract';
              name = 'editLeaseContract';
              title = `编辑${orderName}`;
              query = {
                type: 'edit',
                contractId: row.id,
                rejectFlag: row.auditStatus === '04' ? true : false,
              };
            } else {
              path = 'propert/detailLeaseContract';
              name = 'detailLeaseContract';
              title = `${orderName}详情`;
              query = {
                type: 'detail',
                contractId: row.id,
              };
            }
          } else {
            // 审批
            path = 'property/auditLeaseContract';
            name = 'auditLeaseContract';
            title = `审核${orderName}`;
            query = {
              type: 'audit',
              contractId: row.id,
            };
          }
        } else if (orderName == '报修管理') {
          console.log('报修管理');
          if (this.activeTab == '02') {
            path = '/property/repairBillDetail';
            name = 'repairBillDetail';
            title = '报修管理详情';
            query = {
              pageMode: 4,
              repairId: row.id,
              status: row.auditStatus,
            };
          } else {
            path = '/repairsManagement/auditRepair';
            name = 'auditRepair';
            title = '审核报修单';
            query = {
              pageMode: 3,
              repairId: row.id,
            };
          }
        } else if (orderName == '仓储合同') {
          if (this.activeTab == '02') {
            title = '合同详情';
            query = {
              id: row.id,
              pageMode: 1,
              isEdit: false,
            };
            path = '/park/warehouse/contractDetail';
          } else {
            path = 'warehouse/contractApprove';
            name = 'contractApprove';

            title = '合同审批';
            query = {
              pageMode: 2,
              id: row.id,
              contractNo: row.contractNo,
            };
          }
          // 无审批页面
        } else if (orderName == '监管合同') {
          path = '/park/superviseContract/detail';
          const { contractNo, id } = row;
          name = 'detail';
          title = '监管合同维护';
          query = {
            status: 'detail',
            contractNo: contractNo ? contractNo : '',
            id,
          };
          // 无审批页面
        } else if (orderName == '应收结算') {
          const { publicPath, publicTitle, publicName } = this.handleReciveSettlement(row);
          path = `receivablesAndPayables/${publicName}`;
          title = publicTitle;
          name = publicPath;
          query = {
            status: 'detail',
            id: row.id,
            receiveNo: row.receivableSettlementNo,
          };
          console.log('应收结算', path, title, query, name);
          // 无审批页面
        } else if (orderName == '三方监管') {
          path = '/park/leaseContract/leaseDetail';
          const { contractNo, id } = row;
          name = 'leaseDetail';
          title = '三方仓库租赁合同维护';
          query = {
            status: 'detail',
            contractNo: contractNo ? contractNo : '',
            id,
          };
        } else if (orderName == '立项') {
          query.pageMode = 1;
          title = '项目详情';
          query.serviceTypeName = row.serviceTypeName;
          query.projectCode = row.projectCode;
          let suffix = 'projectDetails';
          query.suffix = suffix;
          path = '/park/warehouse/' + suffix;
          name = suffix;
        }
      }
      //   多式联运
      if (this.indexType == 'dsly') {
        if (orderName == '项目') {
          path = '/intermodality/projectDetail';
          query = { pageMode: 1, origin: 'detail', projectCode: row.projectCode };
        } else if (orderName == '客方合同') {
          path = '/intermodality/customerContractDetail';
          name = 'customerContractDetail';
          query = { contractCode: row.contractCode, pageMode: 1, origin: 'detail' };
        } else if (orderName == '供方合同') {
          path = '/intermodality/supplierContractDetail';
          name = 'supplierContractDetail';
          query = { contractCode: row.contractCode, pageMode: 1, origin: 'detail' };
        } else if (orderName == '应付结算') {
          path = '/receivablesAndPayables/multimodalTransportPayablesDetail';
          query = {
            status: 'detail',
            payNo: row.payableSettlementNo,
            id: row.id,
          };
        } else if (orderName == '应收结算') {
          const { publicPath, publicTitle, publicName } = this.handleReciveSettlement(row);
          path = `receivablesAndPayables/${publicName}`;
          title = publicTitle;
          name = publicPath;
          query = {
            status: 'detail',
            id: row.id,
            receiveNo: row.receivableSettlementNo,
          };
        } else if (orderName == '销售发票申请') {
          path = '/saleInvoice/detail';
          // name = 'detail';
          title = '销售开票详情';
          name = 'saleInvoiceDetail';
          query = { id: row.id, isEdit: 'N' };
        } else if (orderName == '付款申请') {
          path = '/payment/paymentApplyDetail';
          name = 'paymentApplyDetail';
          query = { id: row.id, isEdit: 'N' };
          title = '付款申请单详情';
        } else if (orderName == '客方结算条款') {
          path = '/intermodality/customerContractDetail';
          name = 'customerContractDetail';
          query = { contractCode: row.contractCode, pageMode: 1, origin: 'detail' };
        } else if (orderName == '供方结算条款') {
          // let query = {};
          // // let title = '';
          // let suffix = 'projectCreation';
          // query.pageMode = 1;
          // query.origin = 'detail';
          // title = '项目详情';
          // query.projectCode = row.projectCode;
          // if (origin == 'detail') {
          //   suffix = 'projectDetail';
          // }
          // path = '/intermodality/' + suffix;
          // name = suffix;
          // /intermodality/supplierContractDetail?contractCode=DLHT0731&pageMode=1&origin=detail

          path = '/intermodality/supplierContractDetail';
          // name = 'customerContractDetail';
          name = 'supplierContractDetail';
          // title="'供方合同详情'"
          query = { contractCode: row.contractCode, pageMode: 1, origin: 'detail' };
        }
      }

      // 城矿
      if (this.indexType == 'ck') {
        if (orderName == '立项') {
          name = 'projectCreate';
          title = '编辑项目立项';
          query = {
            id: row.id,
            isEdit: false,
            isCreate: false,
            isView: true,
          };
          path = '/projectInitiation/projectCreate';
        } else if (orderName == '销售协议') {
          const { contractDetailCategory, contractNo, id, contractStatus } = row;
          if (contractDetailCategory == 'CG03') {
            path = '/salePurchase/saleAgreementEdit';
            name = 'saleAgreementEdit';
            title = '销售协议编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            };
          }
          if (contractDetailCategory == 'CG04') {
            path = '/salePurchase/saleContractEdit';
            name = 'saleContractEdit';
            title = '销售合同编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            };
          }
        } else if (orderName == '销售合同') {
          const { contractDetailCategory, contractNo, id, contractStatus } = row;
          if (contractDetailCategory == 'CG03') {
            path = '/salePurchase/saleAgreementEdit';
            name = 'saleAgreementEdit';
            (title = '销售协议编辑'),
              (query = {
                id: id,
                type: contractDetailCategory,
                contractNo: contractNo,
                contractCategory: 'sales',
                isEdit: contractStatus === 'ZT03' ? true : false,
              });
          }
          if (contractDetailCategory == 'CG04') {
            path = '/salePurchase/saleContractEdit';
            name = 'saleContractEdit';
            title = '销售合同编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            };
          }
        } else if (orderName == '采购合同') {
          //已生效的 只能修改关联明细和点价已经结算批次
          const contractDetailCategory = row.contractDetailCategory;
          const contractNo = row.contractNo;
          // const contractStatus = value.row.contractStatus;
          const id = row.id;
          //采购协议
          if (contractDetailCategory == 'CG02') {
            path = '/salePurchase/purchaseAgreementEdit';
            name = 'purchaseAgreementEdit';
            title = '采购协议编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              isEdit: true,
              copy: '0',
              contractCategory: 'purchase',
            };
          }
          // 采购合同
          if (contractDetailCategory == 'CG01') {
            path = '/salePurchase/purchaseContractEdit';
            name = 'purchaseContractEdit';
            title = '采购合同编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              isEdit: true,
              contractCategory: 'purchase',
            };
          }
          // path =
          //   '/salePurchase/purchaseAgreementEdit?id=2222463&type=CG02&contractNo=CGXY0300269&isEdit=true&copy=0&contractCategory=purchase';
        } else if (orderName == '应付结算') {
          let publicName = '';
          let publicPath = '';
          let publicTitle = '';
          if (['01'].includes(row.settlementBusinessType)) {
            publicPath = 'tradePayablesDetail';
            publicName = 'tradePayablesDetail';
            publicTitle = '贸易应付结算单';
          } else if (['02'].includes(row.settlementBusinessType)) {
            publicPath = 'multimodalTransportPayablesDetail';
            publicName = 'multimodalTransportPayablesDetail';
            publicTitle = '多式联运应付结算单';
          } else if (['04'].includes(row.settlementBusinessType)) {
            publicPath = 'leaseContractDetail';
            publicName = 'leaseContractDetail';
            publicTitle = '三方租赁应付结算单 ';
          } else if (['03'].includes(row.settlementBusinessType)) {
            publicPath = 'parkPropertyPayablesDetail';
            publicName = 'parkPropertyPayablesDetail';
            publicTitle = '园区物业应付结算单';
          }
          path = `receivablesAndPayables/${publicPath}`;
          title = publicTitle;
          name = publicName;
          query = {
            status: 'detail',
            payNo: row.payableSettlementNo,
            id: row.id,
          };
        } else if (orderName == '应收结算') {
          const { publicPath, publicTitle, publicName } = this.handleReciveSettlement(row);
          path = `receivablesAndPayables/${publicName}`;
          title = publicTitle;
          name = publicPath;
          query = {
            status: 'detail',
            id: row.id,
            receiveNo: row.receivableSettlementNo,
          };
        } else if (orderName == '销售发票申请') {
          console.log('进入销售发票');
          path = '/saleInvoice/detail';
          name = 'saleInvoiceDetail';
          title = '销售发票详情';
          query = { id: row.id, isEdit: 'N' };
        } else if (orderName == '付款申请') {
          path = '/payment/paymentApplyDetail';
          name = 'paymentApplyDetail';
          title = '付款申请单详情';
          query = { id: row.id, isEdit: 'N' };
        }
      }

      // 物贸
      if (this.indexType == 'wm') {
        if (orderName == '销售合同') {
          const { contractDetailCategory, contractNo, id, contractStatus } = row;
          if (contractDetailCategory == 'CG03') {
            path = '/salePurchase/wumaoSaleAgreementEdit';
            name = 'wumaoSaleAgreementEdit';
            title = '销售协议编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            };
          }
          if (contractDetailCategory == 'CG04') {
            path = '/salePurchase/wumaoSaleContractEdit';
            name = 'wumaoSaleContractEdit';
            title = '销售合同编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            };
          }
        } else if (orderName == '服务合同') {
          path = 'salePurchase/serviceContractDetail';
          name = 'serviceContractDetail';
          query = {
            contractCode: row.contractCode,
            status: 'detail',
            contractStatus: row.contractStatus,
            id: row.id,
          };
        } else if (orderName == '采购合同') {
          //已生效的 只能修改关联明细和点价已经结算批次
          const contractDetailCategory = row.contractDetailCategory;
          const contractNo = row.contractNo;
          // console.log(contractDetailCategory, '==当前类型=??');
          // const contractStatus = value.row.contractStatus;
          const id = row.id;
          //采购协议
          if (contractDetailCategory == 'CG02') {
            path = '/salePurchase/wumaoAgreementEdit';
            name = 'wumaoAgreementEdit';

            title = '采购协议编辑';

            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              isEdit: true,
              copy: '0',
              contractCategory: 'purchase',
            };
          }
          // 采购合同
          if (contractDetailCategory == 'CG01') {
            path = '/salePurchase/wumaoContractEdit';
            name = 'wumaoContractEdit';

            title = '采购合同编辑';
            query = {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              isEdit: true,
              contractCategory: 'purchase',
            };
          }
        } else if (orderName == '双边合同') {
          path = '/saleManage/bilateralContractDetail';
          name = 'bilateralContractDetail';
          title = '双边合同详情';
          query = {
            status: 'detail',
            id: row.id,
            contractNo: row.contractNo,
            contractCategory: row.contractCategory,
          };
        } else if (orderName == '信用证开征查询') {
          path = '/letterOfCredit/applicationForCredit';
          name = 'applicationForLC';
          query = { isEdit: 'N', applicationId: row.id, clType: row.clType };
          if (['001', '002', '003'].indexOf(row.statusFlag) !== -1) {
            path = '/letterOfCredit/applicationForCredit';
            name = 'applicationForLC';
          } else if (['004'].indexOf(row.statusFlag) !== -1) {
            path = '/letterOfCredit/issuing';
            name = 'issuingLC';
          } else if (['005', '006', '007', '008', '009'].indexOf(row.statusFlag) !== -1) {
            path = '/letterOfCredit/acceptance';
            name = 'acceptanceLC';
          }
        } else if (orderName == '立项') {
          path = '/projectInitiation/wuMaoProjectDetail';
          name = 'wuMaoProjectDetail';
          query = {
            status: 'detail',
            id: row.id,
          };
          title = '项目立项详情';
        } else if (orderName == '应付结算') {
          let { publicPath, publicTitle, publicName } = this.handlePaySettlement(row);
          publicPath = publicPath ? publicPath : 'tradePayablesDetail';
          path = `receivablesAndPayables/${publicPath}`;
          title = publicTitle;
          name = publicName;
          query = {
            status: 'detail',
            payNo: row.payableSettlementNo,
            id: row.id,
          };
        } else if (orderName == '应收结算') {
          const { publicPath, publicTitle, publicName } = this.handleReciveSettlement(row);
          path = `receivablesAndPayables/${publicName}`;
          title = publicTitle;
          name = publicPath;
          query = {
            status: 'detail',
            id: row.id,
            receiveNo: row.receivableSettlementNo,
          };
        } else if (orderName == '销售发票申请') {
          path = '/saleInvoice/detail';
          name = 'saleInvoiceDetail';
          title = '销售发票详情';
          query = { id: row.id, isEdit: 'N' };
        } else if (orderName == '付款申请') {
          path = '/payment/paymentApplyDetail';
          name = 'paymentApplyDetail';
          title = '付款申请单详情';
          query = { id: row.id, isEdit: 'N' };
        }
      }

      // 主数据
      if (orderName == '合作伙伴') {
        path = '/masterData/editCooperation';
        name = 'editCooperation';
        title = '合作伙伴详情';
        query = {
          id: row.id,
          partnerCode: row.partnerCode,
          partnerZhName: row.partnerZhName,
          departmentCode: row.departmentCode,
        };
        if (this.indexType == 'wm' && this.activeTab == '03') {
          query.from = 'todo';
        }
      } else if (orderName == '商品主数据') {
        path = '/masterData/goodsDetail';
        name = 'goodsDetail';
        title = '商品详情';
        query = {
          propsGoodsId: row.id,
        };
        if (this.indexType == 'wm' && this.activeTab == '03') {
          query.from = 'todo';
        }
        if (row.parentProductStatus == 'ZT06') {
          //草稿
          path = '/masterData/editGoods';
          name = 'editGoods';
          title = '商品维护';
        }
      } else if (orderName == '商品子类主数据') {
        path = '/masterData/goodsDetail';
        name = 'goodsDetail';
        title = this.$t('goods.titile.goodsDetail');
        query = {
          propsGoodsId: row.pid,
          productDetailCode: row.productDetailCode,
        };
      } else if (orderName == '仓库主数据') {
        //一级仓库
        path = `/storeMasterData/firstLevelDetail`;
        name = 'firstLevelDetail';
        title = '编辑仓库';
        query = {
          status: 'update',
          rowId: row.id, // 行数据带过去
        };
        if (this.indexType == 'wm' && this.activeTab == '03') {
          query.from = 'todo';
        }
      } else if (orderName == '人员') {
        if (row.dataStatusCode == 'ZT06') {
          path = '/masterData/editPersonnel';
          name = 'editPersonnel';
          title = '人员主数据';
        } else {
          path = '/masterData/viewPersonnel';
          name = 'viewPersonnel';
          title = '人员主数据';
        }
        query = { id: row.id, version: row.version };
      }

      let routepath = {
        path: path,
        name: name,
        meta: {
          keepAlive: true,
          title: title,
        },
        query: query,
      };
      return routepath;
    },
    // 根据状态返回字典和路径
    handleStatus(orderName) {
      let statusListMap = [];
      let path = '';
      console.log('路径', orderName);
      console.log(statusListMap, path);
      switch (orderName) {
        case '租赁合同':
          statusListMap = [
            { label: '待提交', value: '01' },
            { label: '待审核', value: '02' },
            { label: '审核通过', value: '03' },
            { label: '审核驳回', value: '04' },
            { label: '暂停审批中', value: '05' },
            { label: '启用审批中', value: '06' },
            { label: '关闭审批中', value: '07' },
          ];
          path = API.LEASECONTRACT;
          break;
        case '物业合同':
          statusListMap = [
            { label: '待提交', value: '01' },
            { label: '待审核', value: '02' },
            { label: '审核通过', value: '03' },
            { label: '审核驳回', value: '04' },
            { label: '暂停审批中', value: '05' },
            { label: '启用审批中', value: '06' },
            { label: '关闭审批中', value: '07' },
          ];
          path = API.LEASECONTRACT;
          break;
        case '报修管理':
          console.log('进入报修管理');
          statusListMap = [
            { value: '01', label: '待提交' },
            { value: '02', label: '审核中' },
            { value: '03', label: '审核通过' },
            { value: '04', label: '审核驳回' },
          ];
          path = API.REPAIR;
          break;
        case '仓储合同':
          statusListMap = this.dictListMap?.warehouseContractStatus;
          path = API.PARKCONTRACT;
          break;
        case '监管合同':
          statusListMap = this.dictListMap?.SuperviseContractStatusType;
          path = API.SUPERVISECONTRACT;
          break;
        case '三方监管':
          statusListMap = this.dictListMap?.SuperviseContractStatusType1;
          path = API.SANFANGLEASECONTRACT;
          break;
        case '应收结算':
          statusListMap = this.dictListMap?.settlementStatus;
          path = API.RECEIVESETTLEMENT;
          break;
        case '应付结算':
          statusListMap = this.dictListMap?.settlementStatus;
          path = API.PAYSETTLEMENT;
          break;
        case '项目':
          // let contractMap = {
          //   ZT01: '已保存',
          //   ZT02: '审批中',
          //   ZT03: '已生效',
          //   ZT04: '已驳回',
          //   ZT05: '已停用',
          //   ZT06: '修订审批中',
          //   ZT07: '修订已驳回',
          // };
          statusListMap = [
            { value: 'xmzt01', label: '已保存' },
            { value: 'xmzt02', label: '审批中' },
            { value: 'xmzt03', label: '审批通过' },
            { value: 'xmzt04', label: '已驳回' },
            { value: 'xmzt05', label: '执行中' },
            { value: 'xmzt06', label: '已作废' },
          ];
          path = API.MULTIPROJECT;
          break;
        case '销售发票申请':
          // console.log("进入销售发票申请")
          statusListMap = this.dictListMap?.invoice_status;
          path = API.SALESORDER;
          break;
        case '付款申请':
          statusListMap = this.dictListMap?.payment_apply_request_status;
          path = API.PAYSUPPLY;
          break;
        case '立项':
          // 物贸立项
          if (this.userInfo.businessGroup == '物贸') {
            path = API.WUMAOPROJECT; //wumao
            statusListMap = this.dictListMap?.PROJECT_INITIATION_STATUS;
          } else if (this.indexType == 'cd') {
            path = API.CHANGDANLIXIANG;
            statusListMap = [
              { value: 'ZT01', label: '草稿' },
              { value: 'ZT02', label: '已作废' },
              { value: 'ZT03', label: '审批中' },
              { value: 'ZT04', label: '审批通过' },
              { value: 'ZT05', label: '项目执行中' },
              { value: 'ZT06', label: '审批驳回' },
            ];
          } else {
            path = API.CHENGKUANGPROJECT; //chegkuang
            statusListMap = this.dictListMap?.PROJECT_INITIATION_STATUS;
          }
          break;
        case '贸易立项':
          if (this.userInfo.businessGroup == '物贸') {
            path = API.WUMAOPROJECT; //wumao
          } else {
            path = API.CHENGKUANGPROJECT; //chegkuang
          }
          statusListMap = this.dictListMap?.PROJECT_INITIATION_STATUS;
          break;
        case '服务合同':
          statusListMap = this.dictListMap?.serviceContractStatus;
          path = API.SERVICECONTRACT;
          break;
        case '信用证开征查询':
          // statusListMap = this.dictListMap?.cl - status - flag;
          break;
        case '合作伙伴':
          statusListMap = this.dictListMap?.request_status;
          path = API.PARTNER;
          break;
        case '人员':
          statusListMap = this.dictListMap?.PROJECT_INITIATION_STATUS;
          break;
        case '客方合同':
          statusListMap = this.dictListMap?.intermodality_contract_statu;
          path = API.MTOCONTRACT;
          break;
        case '供方合同':
          statusListMap = this.dictListMap?.intermodality_contract_statu;
          path = API.MTOCONTRACT;
          break;
        case '客方结算条款':
          statusListMap = this.dictListMap?.intermodality_contract_statu;
          path = API.MTOCONTRACT;
          break;
        case '供方结算条款':
          statusListMap = this.dictListMap?.intermodality_contract_statu;
          path = API.MTOCONTRACT;
          break;
        case '销售合同':
          path = API.SALESANDPURCHASECONTRACT;
          statusListMap = this.dictListMap?.contract_status;
          break;
        case '销售协议':
          path = API.SALESANDPURCHASECONTRACT;
          statusListMap = this.dictListMap?.contract_status;
          break;
        case '采购合同':
          path = API.SALESANDPURCHASECONTRACT;
          statusListMap = this.dictListMap?.contract_status;
          break;
        case '仓库主数据':
          path = API.STOREMASTERDATA;
          statusListMap = approvalTypeList;
          break;
        case '商品主数据':
          path = API.GOODSMASTER;
          statusListMap = this.dictListMap?.request_status;
          break;
        case '双边合同':
          path = API.BILATERALCONTRACT;
          statusListMap = this.dictListMap?.contract_status;
          break;
      }
      let result = { statusListMap, path };
      return result;
    },

    // 处理应收结算
    handleReciveSettlement(row) {
      console.log('处理应收结算', row.settlementBusinessType);
      let publicName = '';
      let publicTitle = '';
      let publicPath = '';
      if (['01'].includes(row.settlementBusinessType)) {
        publicName = publicPath = 'tradeReceivablesDetail';
        publicTitle = '贸易应收结算单';
      }
      if (['02'].includes(row.settlementBusinessType)) {
        publicName = publicPath = 'multimodalTransportReceivablesDetail';
        publicTitle = '多式联运应收结算单';
      }
      if (['03'].includes(row.settlementBusinessType)) {
        publicName = publicPath = 'parkWarehouseReceivablesDetail';
        publicTitle = '园区仓储应收结算单';
      }
      if (['04'].includes(row.settlementBusinessType)) {
        publicName = publicPath = 'parkPropertyReceivablesDetail';
        publicTitle = '园区物业应收结算单';
      }
      if (['05'].includes(row.settlementBusinessType)) {
        publicName = publicPath = 'superviseContractDetail';
        publicTitle = '监管单应收结算费用清单';
      }
      return { publicName, publicTitle, publicPath };
    },
    // 处理应付结算
    handlePaySettlement(row) {
      let publicName = '';
      let publicPath = '';
      let publicTitle = '';
      if (['01'].includes(row.settlementBusinessType)) {
        publicPath = 'tradePayablesDetail';
        publicName = 'tradePayablesDetail';
        publicTitle = '贸易应付结算单';
      } else if (['02'].includes(row.settlementBusinessType)) {
        publicPath = 'multimodalTransportPayablesDetail';
        publicName = 'multimodalTransportPayablesDetail';
        publicTitle = '多式联运应付结算单';
      } else if (['04'].includes(row.settlementBusinessType)) {
        publicPath = 'leaseContractDetail';
        publicName = 'leaseContractDetail';
        publicTitle = '三方租赁应付结算单 ';
      } else if (['03'].includes(row.settlementBusinessType)) {
        publicPath = 'parkPropertyPayablesDetail';
        publicName = 'parkPropertyPayablesDetail';
        publicTitle = '园区物业应付结算单';
      }
      return { publicPath, publicName, publicTitle };
    },
  },
};
